module.exports = __webpack_public_path__ + "public/Icons/twitter.png?5da897a5";